<template>
  <div class="wrapper">
    <div class="container">
      <button class="btn btn-default-back" @click="$router.back()">Back</button>
      <img src="../../assets/chameleon-magnifying-glass.png" alt="not a premium member" />
      <h1>You must be a full member to access this.</h1>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.wrapper {
  padding-top: 1rem;
  width: 100%;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .container {
    width: 60%;
    text-align: center;

    img {
      margin-top: 15%;
      width: 40%;
    }

    h1 {
      @media (max-width: 450px) {
        font-size: 2.6rem;
      }
    }

    @media (max-width: 900px) {
      width: 80%;
      margin-top: 4rem;
    }
    @media (max-width: 600px) {
      margin-top: 5rem;
      width: 80%;
    }

    .btn {
      position: absolute;
      margin-left: -130px;
      margin-top: 22px;
      @media (max-width: 900px) {
        top: 5rem;
        margin-left: 0rem;
      }
    }
  }
}
</style>
